import { Switch } from 'react-router'
import { Route } from 'react-router-dom'
import Loading from 'components/common/loading'
import Loadable from 'react-loadable'
import React from 'react'
import { metadata } from 'app-config'
import { GenericError } from 'components/error-pages'
import ErrorCodes from 'utils/errorCodes'
//import { withRefreshedStore } from 'redux/store-manager'

// import Orders from '../orders/orders.js'

const Assets = Loadable({
    loader: () => import('./asset-listing/index.js'),
    loading: () => (
        <Loading
            center
            size="40px"
            thickness="1px"
            paddingAround="200px"
            message="Loading Assets"
        />
    )
})
const Asset = Loadable({
    loader: () => import('./asset/index.js'),
    loading: () => (
        <Loading
            center
            size="40px"
            thickness="1px"
            paddingAround="200px"
            message="Loading Asset Data"
        />
    )
})

const Routes = () => {
    return (
        <Switch>
            <Route exact path={metadata.assets.route} component={Assets} />
            <Route exact path={metadata.asset.route} component={Asset} />
            <Route
                render={props => {
                    return <GenericError errorObj={ErrorCodes.NOT_FOUND} />
                }}
            />
        </Switch>
    )
}

export default Routes
